import ArgonTypography from "components/ArgonTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React from "react";
import ArgonBox from "components/ArgonBox";
import Card from "@mui/material/Card";
import Footer from "examples/Footer";
import { Button, InputLabel, Box, Avatar } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import ArgonInput from "components/ArgonInput";
import ArgonButton from "components/ArgonButton";
import axios from "utils/api";
import { baseURL } from "utils/api";
import { toast } from "react-toastify";
import PermissionTable from "components/PermissionTable/PermissionTable";
import { getAllPermissions } from "utils/permissionConstants";

function AddTutor() {
  const navigate = useNavigate();

  // Form state
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    password: "",
  });

  // Permissions state - now an object with CRUD operations
  const [selectedPermissions, setSelectedPermissions] = useState({});
  const [selectAllModules, setSelectAllModules] = useState(false);
  const [loading, setLoading] = useState(false);

  // Handle permission changes
  const handlePermissionChange = (newPermissions) => {
    setSelectedPermissions(newPermissions);

    // Check if all modules are selected
    const allPerms = getAllPermissions();
    const allSelected = JSON.stringify(newPermissions) === JSON.stringify(allPerms);
    setSelectAllModules(allSelected);
  };

  // Handle select all modules
  const handleSelectAllModules = () => {
    if (selectAllModules) {
      // Deselect all
      setSelectedPermissions({});
      setSelectAllModules(false);
    } else {
      // Select all
      const allPerms = getAllPermissions();
      setSelectedPermissions(allPerms);
      setSelectAllModules(true);
    }
  };

  // Input handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  //const token = localStorage.getItem("token");

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check if at least one permission is selected
    const hasPermissions = Object.values(selectedPermissions).some((modulePerms) =>
      Object.values(modulePerms).some((val) => val === true)
    );

    if (!hasPermissions) {
      toast.error("Please assign at least one permission to create Sub-Admin!");
      return;
    }

    console.log("Submitting Sub-Admin form...");
    console.log("Selected Permissions:", selectedPermissions);

    setLoading(true);

    axios
      .post(`${baseURL}/user`, {
        fullName: formData.fullName,
        email: formData.email,
        password: formData.password,
        permissions: selectedPermissions, // Send object with CRUD operations
      })
      .then((res) => {
        console.log("Response:", res.data);
        if (res.data.success) {
          toast.success(res.data.message || "Sub-Admin created successfully!");
          setFormData({
            fullName: "",
            email: "",
            password: "",
          });
          setSelectedPermissions({});
          setSelectAllModules(false);
          navigate("/subadmin");
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("❌ Error creating Sub-Admin:", err);
        if (err.response && err.response.data) {
          toast.error(err.response.data.error || "Failed to create Sub-Admin");
        } else {
          toast.error("Something went wrong. Please try again!");
        }
        setLoading(false);
      });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card
            sx={{
              boxShadow: "0 8px 30px rgba(0,0,0,0.1)",
              borderRadius: "20px",
              overflow: "hidden",
              border: "1px solid #e0e6ff",
            }}
          >
            <ArgonBox p={4}>
              {/* Header */}
              <ArgonBox
                mb={4}
                textAlign="center"
                sx={{
                  // background: "linear-gradient(135deg, #4f8aff, #6c63ff)",
                  borderRadius: "12px",
                  py: 3,
                  color: "white",
                }}
              >
                <ArgonTypography variant="h4" fontWeight="bold" mb={1}>
                  Add Sub-Admin
                </ArgonTypography>
                <ArgonTypography variant="body2" sx={{ opacity: 0.9 }}>
                  Fill in the details to create a new Sub-Admin account
                </ArgonTypography>
              </ArgonBox>

              {/* FORM START */}
              <form onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                  {/* Full Name */}
                  <Grid item xs={12} md={6}>
                    <InputLabel sx={{ mb: 1, display: "flex", alignItems: "center" }}>
                      <PersonIcon color="primary" sx={{ fontSize: 18, mr: 1 }} />
                      <ArgonTypography variant="body2" fontWeight="medium">
                        Full Name
                      </ArgonTypography>
                    </InputLabel>
                    <ArgonInput
                      fullWidth
                      name="fullName"
                      placeholder="Enter full name"
                      value={formData.fullName}
                      onChange={handleChange}
                      variant="outlined"
                      sx={{
                        borderRadius: "10px",
                        "& .MuiOutlinedInput-root": {
                          background: "#fafbff",
                          boxShadow: "inset 0 2px 6px rgba(0,0,0,0.05)",
                          "&:hover fieldset": { borderColor: "#4f8aff" },
                        },
                      }}
                    />
                  </Grid>

                  {/* Email */}
                  <Grid item xs={12} md={6}>
                    <InputLabel sx={{ mb: 1, display: "flex", alignItems: "center" }}>
                      <EmailIcon color="primary" sx={{ fontSize: 18, mr: 1 }} />
                      <ArgonTypography variant="body2" fontWeight="medium">
                        Email Address
                      </ArgonTypography>
                    </InputLabel>
                    <ArgonInput
                      fullWidth
                      name="email"
                      type="email"
                      placeholder="Enter email address"
                      value={formData.email}
                      onChange={handleChange}
                      variant="outlined"
                      sx={{
                        borderRadius: "10px",
                        "& .MuiOutlinedInput-root": {
                          background: "#fafbff",
                          boxShadow: "inset 0 2px 6px rgba(0,0,0,0.05)",
                          "&:hover fieldset": { borderColor: "#4f8aff" },
                        },
                      }}
                    />
                  </Grid>

                  {/* Password */}
                  <Grid item xs={12} md={6}>
                    <InputLabel sx={{ mb: 1, display: "flex", alignItems: "center" }}>
                      <LockIcon color="primary" sx={{ fontSize: 18, mr: 1 }} />
                      <ArgonTypography variant="body2" fontWeight="medium">
                        Password
                      </ArgonTypography>
                    </InputLabel>
                    <ArgonInput
                      fullWidth
                      name="password"
                      type="password"
                      placeholder="Enter password"
                      value={formData.password}
                      onChange={handleChange}
                      variant="outlined"
                      sx={{
                        borderRadius: "10px",
                        "& .MuiOutlinedInput-root": {
                          background: "#fafbff",
                          boxShadow: "inset 0 2px 6px rgba(0,0,0,0.05)",
                          "&:hover fieldset": { borderColor: "#4f8aff" },
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Permissions Section */}
                <PermissionTable
                  selectedPermissions={selectedPermissions}
                  onPermissionChange={handlePermissionChange}
                  selectAllModules={selectAllModules}
                  onSelectAllModules={handleSelectAllModules}
                />

                {/* Buttons */}
                <ArgonBox display="flex" justifyContent="flex-end" mt={3} gap={2}>
                  <ArgonButton
                    variant="outlined"
                    color="primary"
                    sx={{ borderRadius: "10px", px: 3, fontWeight: "bold" }}
                    onClick={() => navigate("/subadmin")}
                  >
                    Cancel
                  </ArgonButton>
                  <ArgonButton
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{
                      borderRadius: "10px",
                      px: 4,
                      fontWeight: "bold",
                      boxShadow: "0 4px 12px rgba(79,138,255,0.4)",
                    }}
                    disabled={loading}
                  >
                    {loading ? "Saving..." : "Save"}
                  </ArgonButton>
                </ArgonBox>
              </form>
            </ArgonBox>
          </Card>
        </ArgonBox>
      </ArgonBox>

      <Footer />
    </DashboardLayout>
  );
}

export default AddTutor;

//  <DashboardLayout>
//     <DashboardNavbar />

//     <ArgonBox py={3}>
//       <ArgonBox mb={3}>
//         <Card sx={{ boxShadow: '0 4px 20px rgba(0,0,0,0.1)', borderRadius: '16px' }}>
//           <ArgonBox p={4}>
//             {/* Header */}
//             <ArgonBox mb={4} textAlign="center">
//               <ArgonTypography variant="h4" fontWeight="bold" color="primary" mb={1}>
//                 Add Sub-Admin
//               </ArgonTypography>
//               <ArgonTypography variant="body2" color="text" opacity={0.7}>
//                 Fill in the details to create a new Sub-Admin account
//               </ArgonTypography>
//             </ArgonBox>

//             {/* FORM START */}
//             <form onSubmit={handleSubmit}>
//               <Grid container spacing={3}>
//                 {/* Profile Image */}
//                 {/* <Grid item xs={12} display="flex" justifyContent="center" mb={2}>
//                   <ArgonBox position="relative">
//                     <Avatar
//                      src={preview ||""}
//                       sx={{
//                         width: 100,
//                         height: 100,
//                         backgroundColor: '#f5f5f5',
//                         borderRadius:"50px"
//                         // border: '3px solid #e0e0e0'
//                       }}
//                     >
//                        {!preview && (
//                        <PersonIcon color="primary" sx={{ fontSize: 40, color: "#999" }} />
//                         )}
//                     </Avatar>
//                     <ArgonButton
//                       component="label"
//                       sx={{
//                         position: 'absolute',
//                         bottom: -5,
//                         right: -5,
//                         minWidth: 'auto',
//                         width: 35,
//                         height: 35,
//                         borderRadius: '50%',
//                         backgroundColor: 'primary.main',
//                         '&:hover': { backgroundColor: 'primary.dark' }
//                       }}
//                     >
//                       <PhotoCameraIcon sx={{ fontSize: 18, color: 'white !important' }} />
//                       <input
//                         type="file"
//                         name="profileImage"
//                         hidden
//                         accept="image/*"
//                         onChange={handleChange1}
//                       />
//                     </ArgonButton>
//                   </ArgonBox>
//                 </Grid> */}

//                 {/* Name */}
//                 <Grid item xs={12} md={6}>
//                   <InputLabel display="flex" sx={{ mb: 1, fontWeight: 'medium', color: 'text.primary' }}>
//                     <PersonIcon color='primary' sx={{ fontSize: 18, mr: 1, verticalAlign: 'middle' }} />
//                     <ArgonTypography variant="caption" fontWeight="medium" color="text" fontSize="16px">Full Name</ArgonTypography>
//                   </InputLabel>
//                   <ArgonInput
//                     fullWidth
//                     name="name"
//                     placeholder="Enter full name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     variant="outlined"

//                   />
//                 </Grid>

//                 {/* Phone No. */}
//                 {/* <Grid item xs={12} md={6}>
//                   <InputLabel sx={{ mb: 1, fontWeight: 'medium', color: 'text.primary' }}>
//                     <PhoneIcon color='primary' sx={{ fontSize: 18, mr: 1, verticalAlign: 'middle' }} />
//                    <ArgonTypography variant="caption" fontWeight="medium" color="text" fontSize="16px">Phone Number</ArgonTypography>
//                   </InputLabel>
//                   <ArgonInput
//                     fullWidth
//                     name="phone"
//                     placeholder="Enter phone number"
//                     value={formData.phone}
//                     onChange={handleChange}
//                     variant="outlined"

//                   />
//                 </Grid> */}

//                 {/* Email */}
//                 <Grid item xs={12} md={6}>
//                   <InputLabel sx={{ mb: 1, fontWeight: 'medium', color: 'text.primary' }}>
//                     <EmailIcon color='primary' sx={{ fontSize: 18, mr: 1, verticalAlign: 'middle' }} />
//                     <ArgonTypography variant="caption" fontWeight="medium" color="text" fontSize="16px">Email Address</ArgonTypography>
//                   </InputLabel>
//                   <ArgonInput
//                     fullWidth
//                     name="email"
//                     type="email"
//                     placeholder="Enter email address"
//                     value={formData.email}
//                     onChange={handleChange}
//                     variant="outlined"
//                   />
//                 </Grid>

//                 {/* Designation */}
//                 {/* <Grid item xs={12} md={6}>
//                   <InputLabel sx={{ mb: 1, fontWeight: 'medium', color: 'text.primary' }}>
//                     <WorkIcon color='primary' sx={{ fontSize: 18, mr: 1, verticalAlign: 'middle' }} />
//                    <ArgonTypography variant="caption" fontWeight="medium" color="text" fontSize="16px">Designation</ArgonTypography>
//                   </InputLabel>
//                   <ArgonInput
//                     fullWidth
//                     name="designation"
//                     placeholder="Enter designation"
//                     value={formData.designation}
//                     onChange={handleChange}
//                     variant="outlined"
//                   />
//                 </Grid> */}

//                 {/* Password */}
//                 <Grid item xs={12} md={6}>
//                   <InputLabel sx={{ mb: 1, fontWeight: 'medium', color: 'text.primary' }}>
//                     <LockIcon color='primary' sx={{ fontSize: 18, mr: 1, verticalAlign: 'middle' }} />
//                     <ArgonTypography variant="caption" fontWeight="medium" color="text" fontSize="16px">Password</ArgonTypography>
//                   </InputLabel>
//                   <ArgonInput
//                     fullWidth
//                     name="password"
//                     type="password"
//                     placeholder="Enter password"
//                     value={formData.password}
//                     onChange={handleChange}
//                     variant="outlined"

//                   />
//                 </Grid>
//               </Grid>

//               {/* Submit Buttons */}
//               {/* <ArgonBox display="flex" justifyContent="center" gap={2} mt={4}>
//                 <ArgonButton
//                   variant="outlined"
//                   component={Link}
//                   to="/subadmin"
//                   color="primary"
//                 >
//                   Cancel
//                 </ArgonButton>
//                 <ArgonButton
//                   type="submit"
//                   variant="contained"
//                   color="primary"

//                 >
//                   Submit
//                 </ArgonButton>
//               </ArgonBox> */}
//             </form>
//             {/* FORM END */}
//           </ArgonBox>
//         </Card>
//       </ArgonBox>
//        <ArgonBox
//     sx={{
//       borderRadius: 3,
//       background: "linear-gradient(145deg, #ffffff, #f9f9ff)",
//       width: "100%",
//       height: "100%",
//       p: 2,
//       boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
//       transition: "all 0.3s ease",
//       "&:hover": {
//         boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
//       },
//     }}
//   >
//     {/* Header */}
//     <ArgonBox
//       display="flex"
//       justifyContent="space-between"
//       alignItems="center"
//       sx={{
//         height: 60,
//         borderBottom: "2px solid #e0e0e0",
//         px: 3,
//         mb: 1,
//       }}
//     >
//       <ArgonTypography
//         variant="h6"
//         fontWeight="bold"
//         sx={{ color: "#080278" }}
//       >
//         Permissions
//       </ArgonTypography>
//       <ArgonTypography variant="body2" fontWeight="bold" color="text.secondary">
//         Is Allowed
//       </ArgonTypography>
//     </ArgonBox>

//     {/* Table */}
//     <ArgonBox p={2}>
//       <form>
//         <ArgonBox
//           sx={{
//             maxHeight: 280,
//             overflowY: "auto",
//             "&::-webkit-scrollbar": {
//               width: "6px",
//             },
//             "&::-webkit-scrollbar-thumb": {
//               background: "#c1c1c1",
//               borderRadius: "6px",
//             },
//           }}
//         >
//           <Table>
//             <TableBody>
//               {/* Static Permissions */}
//               {permissions.map((perm, idx) => (
//                 <TableRow
//                   key={idx}
//                   sx={{
//                     "&:hover": { backgroundColor: "#f5f7ff" },
//                     transition: "0.2s",
//                   }}
//                 >
//                   <TableCell sx={{ fontSize: "0.95rem", fontWeight: 600, color: "#080278" }}>
//                     {perm}
//                   </TableCell>

//                   <TableCell>
//                     <Checkbox name="permissions[]" value={perm} />
//                   </TableCell>
//                 </TableRow>
//               ))}

//               {/* Sections with dropdown */}
//               {sections.map((section, idx) => (
//                 <React.Fragment key={`section-${idx}`}>
//                   <TableRow
//                     sx={{
//                       backgroundColor: "#f1f4ff",
//                     }}
//                   >
//                     <TableCell colSpan={2}>
//                       <ArgonBox display="flex" alignItems="center">
//                         <ArgonTypography
//                           variant="body2"
//                           fontWeight="bold"
//                           fontSize="15px"
//                           sx={{ color: "#080278" }}
//                         >
//                           {section.title}
//                         </ArgonTypography>
//                         <IconButton
//                           size="small"
//                           onClick={() => toggleSection(section.title)}
//                           sx={{
//                             color: "#080278",
//                             ml: 1.5,
//                             transition: "0.2s",
//                             "&:hover": { transform: "scale(1.2)" },
//                           }}
//                         >
//                           <ExpandMore
//                             sx={{
//                               transform: openSections[section.title]
//                                 ? "rotate(180deg)"
//                                 : "rotate(0deg)",
//                               transition: "0.3s",
//                             }}
//                           />
//                         </IconButton>
//                       </ArgonBox>
//                     </TableCell>
//                   </TableRow>

//                   {/* Child Rows */}
//                   {openSections[section.title] &&
//                     section.children.map((child, cidx) => (
//                       <TableRow
//                         key={`child-${idx}-${cidx}`}
//                         sx={{
//                           "&:hover": { backgroundColor: "#f9f9ff" },
//                           transition: "0.2s",
//                         }}
//                       >
//                         <TableCell sx={{ pl: 6, fontSize: "0.9rem",fontWeight: 600, color: "#080278" }}>
//                           {child}
//                         </TableCell>
//                         <TableCell>
//                           <Checkbox  name="permissions[]" value={child} />
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                 </React.Fragment>
//               ))}
//             </TableBody>
//           </Table>
//         </ArgonBox>

//         {/* Actions */}
//         <ArgonBox
//           display="flex"
//           justifyContent="flex-end"
//           mt={3}
//           gap={2}
//         >
//           <ArgonButton
//             variant="outlined"
//             color="primary"
//           >
//             Cancel
//           </ArgonButton>
//           <ArgonButton
//             type="submit"
//             variant="contained"
//             color="primary"
//           >
//             Save
//           </ArgonButton>
//         </ArgonBox>
//       </form>
//     </ArgonBox>
//          </ArgonBox>
//     </ArgonBox>

//     <Footer />
//   </DashboardLayout>
